var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0C14.3559 0 0 14.3559 0 32C0 49.6441 14.3559 64 32 64C49.6441 64 64 49.6441 64 32C64 14.3559 49.6441 0 32 0ZM49.8847 23.5789L29.4336 43.8697C28.2306 45.0727 26.3058 45.1529 25.0226 43.9499L14.1955 34.0852C12.9123 32.8822 12.8321 30.8772 13.9549 29.594C15.1579 28.3108 17.1629 28.2306 18.4461 29.4336L27.0276 37.2932L45.3133 19.0075C46.5965 17.7243 48.6015 17.7243 49.8847 19.0075C51.1679 20.2907 51.1679 22.2957 49.8847 23.5789Z",
    fill: "#122D58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneIcon);
export default __webpack_public_path__ + "static/media/done-icon.ec6ac7f341aa48b9dbd2bba5b8285876.svg";
export { ForwardRef as ReactComponent };